import { GET_BANNER_PRICE } from "../../actions/type";
export default function bannerPrice(state={},action){
    switch(action.type){
        case GET_BANNER_PRICE:
            return action.payload;
        default:
            return state
    }
}